import { Optional } from '@rio/types'
import { RefObject, useCallback, useState } from 'react'

export const useContentAnimation = (
  elementRef: RefObject<HTMLElement | null>,
  content: Optional<string>,
) => {
  const [isAnimationActive, setIsAnimationActive] = useState(false)

  const animateContent = useCallback(() => {
    if (elementRef.current && content) {
      elementRef.current.innerHTML = ''
      const value = content ?? ''
      setIsAnimationActive(true)
      for (let i = 0, l = value.length; i < l; i++) {
        setTimeout(
          index => {
            if (elementRef.current) {
              elementRef.current.innerHTML = value.substring(0, index + 1)
              if (index + 1 >= l) {
                setIsAnimationActive(false)
              }
            }
          },
          i * 10,
          i,
        )
      }
    }
  }, [content, elementRef])

  return {
    animateContent,
    isAnimationActive,
  }
}
